// 城市显示名：库里存中文名（配单按字符串精确匹配，提交值不变），显示时按界面语言换——
// 简体原样、繁体逐字转繁体、其他语言用 cityAliases 的英文名（没收录的原样）。与移动端 utils/format.js 的 cityLabel 同义。
import { cityEnglish } from './cityAliases';
import { toHant } from './hant';

export function cityText(name, code, lang) {
  if (!name) return '';
  if (!lang || lang === 'zh-CN') return name;
  if (lang === 'zh-TW') return toHant(name);
  return cityEnglish({ name, code }) || name;
}

export const routeText = (row, lang, sep = ' → ') => (row
  ? `${cityText(row.origin_city, row.origin_country, lang)}${sep}${cityText(row.dest_city, row.dest_country, lang)}`
  : '');
